// extracted by mini-css-extract-plugin
export default {"container":"CardDragGame_container__giHg1","regions":"CardDragGame_regions__Fu+Kw","cards":"CardDragGame_cards__nuqih","wrongCount":"CardDragGame_wrongCount__2GOZ9"};